module.exports = __webpack_public_path__ + "static/media/FiraSans-Black.e38d2dbc.ttf";